import {
  RESET_FORM,
  UPDATE_NAME,
  UPDATE_EMAIL,
  UPDATE_USERNAME,
  POST_CLIENT,
  POST_CLIENT_START,
  POST_CLIENT_SUCCESS,
  POST_CLIENT_ERROR,
} from './constants'
import {
  buildAsyncAction,
} from 'containers/Async/actions'

const resetForm = () => ({ type: RESET_FORM })
const updateUsername = (username) => ({ type: UPDATE_USERNAME, username })
const updateName = (name) => ({ type: UPDATE_NAME, name })
const updateEmail = (email) => ({ type: UPDATE_EMAIL, email })
const postClient = () => ({ type: POST_CLIENT })
const postClientStart = () => ({ type: POST_CLIENT_START })
const postClientSuccess = () => ({ type: POST_CLIENT_SUCCESS })
const postClientError = (error) => ({ type: POST_CLIENT_ERROR, error })
const startPostClientAsync = buildAsyncAction(
  POST_CLIENT,
  POST_CLIENT_START,
  [POST_CLIENT_SUCCESS, POST_CLIENT_ERROR]
)

export {
  resetForm,
  updateUsername,
  updateName,
  updateEmail,
  postClient,
  postClientStart,
  postClientSuccess,
  postClientError,
  startPostClientAsync,
}
